import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { GetArchiveSilobagsResponse } from './get-archive-silobags.type';
import { useGlobalStore } from '@old/global-store/use-store';
import { transformIntoQueryParamString } from '@old/utils/service';

export async function listArchivableSilobagService() {
  const { organizationId } = useGlobalStore.getState();
  const rawQuery = {
    organization_id: organizationId,
  };

  const query = transformIntoQueryParamString(rawQuery);
  const { response, data } = await BACKEND.get<GetArchiveSilobagsResponse>(ENDPOINT.SILOBAGS_ARCHIVABLE, {
    query,
  });
  return {
    response,
    summary: data,
  };
}
